import { useSpring } from 'react-spring';
import { IUseNotificationItemData, IUseNotificationItemProps } from '../types';

export const useNotificationItem = ({
  markAsRead,
  notification_id,
  is_read,
}: IUseNotificationItemProps): IUseNotificationItemData => {

  const [style] = useSpring(() => ({
    x: 0,
    opacity: 1,
    config: { duration: 400 },
  }));

  const handleMarkAsRead = () => {
    if (!is_read) {
      markAsRead(notification_id);
    }
  };

  return {
    style,
    handleMarkAsRead,
  };
};
